module.exports = __webpack_public_path__ + "static/media/circulation.0109e77c.svg";